
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class LoadingOverlay extends Vue {
  @Prop({ default: '0' }) private borderRadius!: string;
  @Prop({ default: 'rgba(0,0,0,.9)' }) private backgroundColor!: string;
}
